module.exports = __webpack_public_path__ + "img/jsfni4.42148097.png";